/**
 * 处理数据的函数返回绝对值保留4位有效数字
 */
// tslint:disable:no-parameter-reassignment
// tslint:disable-next-line:cyclomatic-complexity
export function retainValidNumbers(value) {
    let num = [];
    try {
        num = value.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/) || [];
    }
    catch (e) {
        console.warn(e);
        console.warn(value);
        return 0;
    }
    // const num = value.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/) || [];
    const strValue = value.toFixed(Math.max(0, (num[1] || "").length - Number.parseInt(num[2], 10)));
    const arr = strValue.split(".");
    const plength = arr[0].length;
    const dlength = (arr[1] && arr[1].length) || 0;
    const dnumber = (arr[1] && arr[1].replace(/\b(0+)/gi, "")) || "";
    const delength = dnumber.length || 0;
    const dilength = dlength - delength;
    let strNumber;
    if (arr[0] === "0") {
        [arr[1]] = [(arr[1] && arr[1].substr(0, dilength + 4)) || "0"];
        strNumber = arr.join(".");
    }
    else if (plength >= 4) {
        strNumber = arr[0];
    }
    else if (dlength) {
        [arr[1]] = [arr[1].substr(0, 4 - plength)];
        strNumber = arr.join(".");
    }
    else {
        strNumber = arr.join(".");
    }
    return Number.parseFloat(strNumber);
}
//# sourceMappingURL=index.js.map